import styled from 'styled-components';
import { FsTopBar } from '@printi/ds-offset-react-core';

export const StyledTopBar = styled(FsTopBar)`
  @media screen and (max-width: 768px) {
    display: none !important;
  }
`;
